const masks = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};
export function dateString(date) {
    return new Date(date).toLocaleDateString('en-US', masks);
}
// eslint-disable-next-line no-extend-native
/*Date.prototype.yyyymmdd = function() {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(),
    (mm>9 ? '' : '0') + mm,
    (dd>9 ? '' : '0') + dd
  ].join('');
};

var date = new Date();
date.yyyymmdd();*/
